import { create } from "zustand";
import { DeletedFileInfo } from "@/components/dialogs/deleted-files-dialog";

interface DeletedFilesDialogState {
  // State
  isOpen: boolean;
  deletedFiles: DeletedFileInfo[];
  isDeleting: boolean;

  // Actions
  setIsOpen: (open: boolean) => void;
  setDeletedFiles: (files: DeletedFileInfo[]) => void;
  setIsDeleting: (deleting: boolean) => void;
  openDialog: (files: DeletedFileInfo[]) => void;
  closeDialog: () => void;
  removeDeletedFiles: (documentIds: string[]) => void;
}

export const useDeletedFilesDialogStore = create<DeletedFilesDialogState>(
  (set) => ({
    // Initial state
    isOpen: false,
    deletedFiles: [],
    isDeleting: false,

    // Setters
    setIsOpen: (open) => set({ isOpen: open }),
    setDeletedFiles: (files) => set({ deletedFiles: files }),
    setIsDeleting: (deleting) => set({ isDeleting: deleting }),

    // Helper to open dialog with files
    openDialog: (files) =>
      set({
        isOpen: true,
        deletedFiles: files,
      }),

    // Helper to close dialog and reset
    closeDialog: () =>
      set({
        isOpen: false,
        deletedFiles: [],
        isDeleting: false,
      }),

    // Helper to remove specific files from list
    removeDeletedFiles: (documentIds) =>
      set((state) => ({
        deletedFiles: state.deletedFiles.filter(
          (f) => !documentIds.includes(f.document.id)
        ),
      })),
  })
);
